const DK = {
  ibanLength: 18,
};
export { DK };
